import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-activity-show',
  templateUrl: './activity-show.component.html',
  styleUrls: ['./activity-show.component.scss']
})
export class ActivityShowComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
